import { render, staticRenderFns } from "./gnzx_xqy.vue?vue&type=template&id=157ff32f&scoped=true&"
import script from "./gnzx_xqy.vue?vue&type=script&lang=js&"
export * from "./gnzx_xqy.vue?vue&type=script&lang=js&"
import style0 from "./gnzx_xqy.vue?vue&type=style&index=0&id=157ff32f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157ff32f",
  null
  
)

export default component.exports